export const truncate = (n) => n !== undefined ? Math.trunc(n) : undefined;
//# sourceMappingURL=math.js.map